module.exports = "<a id=\"btn-scroll-up\" class=\"btn-scroll-up btn btn-sm btn-inverse\">\n\t<i class=\"ace-icon fa fa-angle-double-up icon-only bigger-110\"></i>\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/scroll-up/scroll-up.html
// module id = 539
// module chunks = 0